import { useState } from 'react';
import { BsCaretRight } from 'react-icons/bs';
import CardH from 'src/components/cards-video/card-h';
import { APP_IMG } from 'src/constants';
import styled from 'styled-components';
const SecFullH = ({ data, sectionH = false }) => {
  // const eventDataLayer = {
  //   key: KEY_EVENT.TRACK_EVENT,
  //   event: KEY_EVENT.CARD_CONTENT
  // };
  // console.log('SecFullH', data);
  const [defalutData, setDefalutData] = useState({
    video_type: '',
    video_src: ''
  });
  const [counter, setCounter] = useState(0);
  if (data?.length > 0 && defalutData?.video_src === '') {
    setDefalutData({ video_type: data[0]?.type_video, video_src: data[0]?.video_src });
  }

  const getVideoIframe = () => {
    let urlVideo;
    if (defalutData.video_type === '0') {
      urlVideo = `${APP_IMG}/${defalutData.video_src}`;
    } else {
      urlVideo = defalutData.video_src;
    }
    return <>{defalutData.video_type === '4' ? <div dangerouslySetInnerHTML={urlVideo} /> : <iframe className='video-frame' src={urlVideo} frameBorder='0' />}</>;
  };

  return (
    <>
      {data?.length > 0 && (
        <SectionWrapper className='sec-full-h'>
          <div className='row'>
            <div className={`col-12 video-player ${sectionH ? '--small' : 'col-md-8'}`}>{data?.length > 0 && getVideoIframe()}</div>

            <div className={`col-12 ${sectionH ? '' : 'col-md-4'} card-wrapper`}>
              <div className='playlist-head'>
                <div className='playlist-head-icon'>
                  <BsCaretRight />
                </div>
                <h2>วิดีโอล่าสุด</h2>
                <span className='videos-number'>
                  <span> {counter + 1} </span> / <span> {data?.length} </span> วิดีโอ
                </span>
              </div>
              <div className='video-playlists playlist-custom-scroll --vertical'>
                <ul>
                  {data?.length > 0 &&
                    data.map((item, index) => (
                      <li
                        className={`w-100 ${counter === index ? 'active' : ''}`}
                        key={index}
                        onClick={() => {
                          setDefalutData({ video_type: item.type_video, video_src: item.video_src });
                          setCounter(index);
                        }}
                      >
                        <CardH
                          data={item}
                          number={index + 1}
                        //! DATALAYER
                        // eventDataLayer={eventDataLayer}
                        />
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
        </SectionWrapper>
      )}
    </>
  );
};

const SectionWrapper = styled.div`
  width: 100%;
  margin: 0px;
  .video-player,
  .video-div {
    position: relative;
    height: 434px;
    min-height: 210px; // 250px
    padding: 0;
    @media (max-width: 480px) {
      padding: 0 9px;
    }
    &.--small {
      height: 210px; // 250px
      @media (max-width: 768px) {
        height: 434px;
        min-height: 210px;
      }
      @media (max-width: 480px) {
        height: 250px;
        min-height: 210px;
      }
    }
    iframe {
      width: 100%;
      height: 100%;
      max-height: 434px;
      border-radius: 3px;
      @media (max-width: 480px) {
        border-radius: 3px 3px 0 0;
      }
    }

    @media (max-width: 767px) {
      height: 250px;
    }
  }

  .playlist-head {
    background: #00ff57;
    color: #000;
    height: 60px;
    width: 100%;
    padding: 0 15px;
    line-height: 14px;
    z-index: 9;
    @media (min-width: 480px) {
      border-radius: 3px 3px 0 0;
    }

    h2 {
      color: #000000;
      padding-top: 12px;
      font-size: 18px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin: 0;
      line-height: 1.2;
    }

    .videos-number {
      font-size: 12px;
    }

    .playlist-head-icon {
      font-size: 35px;
      float: left;
      margin-right: 10px;
      height: 60px;
      line-height: 55px;
      width: 40px;
      text-align: center;
      font-weight: bold;
      svg {
        vertical-align: middle;
      }
    }
  }

  .video-playlists {
    position: relative;
    ul {
      padding: 0;
      li {
        display: inline-block;
        list-style-type: none;
        margin-right: 8px;
        cursor: pointer;
        padding: 5px;

        &.active {
          background-image: linear-gradient(to right, rgb(223 223 223 / 36%) 100%, #ffffff 100%) !important;
          h2 {
            color: rgba(0, 170, 44) !important;
          }
          .video-number {
            color: rgba(0, 170, 44) !important;
          }
        }
        &:hover {
          background-color: rgb(223 223 223 / 15%);
          h2 {
            color: rgba(0, 170, 44);
          }
          .video-number {
            color: rgba(0, 170, 44);
          }
        }
      }
    }
  }
`;

export default SecFullH;
